import IntegrationDetails from './IntegrationDetails';

export default IntegrationDetails;
